import {
  getIndicesByPropertyValue
} from 'utilities/collection';

import fieldTypes from '../field-types';

import fileTypes from './options-editors/file/types';

const typeInputOptions = [{
  label: 'Text',
  value: fieldTypes.TEXT
}, {
  label: 'Email',
  value: fieldTypes.EMAIL
}, {
  label: 'Number',
  value: fieldTypes.NUMBER
}, {
  label: 'Text area',
  value: fieldTypes.TEXT_AREA
}, {
  label: 'Dropdown (Single choice selection)',
  value: fieldTypes.SELECT
}, {
  label: 'Checkbox (Multiple choice selection)',
  value: fieldTypes.CHECKBOX_GROUP
}, {
  label: 'Radiobutton (Single choice selection)',
  value: fieldTypes.RADIO_BUTTON_GROUP
}, {
  label: 'File',
  value: fieldTypes.FILE
}];

export function buildTypeInputConfiguration(signupForm, value, onChange) {

  let typeOptions = [...typeInputOptions];

  if (signupForm === true) {
    typeOptions = typeOptions.filter((option) => [fieldTypes.TEXT, fieldTypes.EMAIL].includes(option.value));
  }

  const options = {
    placeholder: 'Select type',
    options: typeOptions,
    selectedOptionIndices: getIndicesByPropertyValue(typeOptions, 'value', value),
    onChange
  };

  return options;

}

export function getDefaultOptionsByType(type) {

  if (type === fieldTypes.TEXT) {

    return {
      placeholder: 'Sample placeholder',
      required: false
    };

  } else if (type === fieldTypes.EMAIL) {

    return {
      placeholder: 'john@sample.com',
      required: false
    };

  } else if (type === fieldTypes.NUMBER) {

    return {
      placeholder: 'Enter a number',
      required: false
    };

  } else if (type === fieldTypes.TEXT_AREA) {

    return {
      placeholder: 'Sample placeholder',
      required: false
    };

  } else if (type === fieldTypes.SELECT) {

    return {
      placeholder: 'Sample placeholder',
      required: false,
      options: ['Sample option #1', 'Sample option #2']
    };

  } else if (type === fieldTypes.CHECKBOX_GROUP) {

    return {
      required: false,
      options: ['Sample option #1', 'Sample option #2']
    };

  } else if (type === fieldTypes.RADIO_BUTTON_GROUP) {

    return {
      required: false,
      options: ['Sample option #1', 'Sample option #2']
    };

  } else if (type === fieldTypes.FILE) {

    return {
      required: false,
      allowedFileTypes: [fileTypes.IMAGE],
      buttonText: 'Select image'
    };

  }

  return {
    placeholder: 'Sample placeholder',
    required: false
  };

}